import React from 'react';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import MarkButton from './MarkButton';

function UnderlineButton() {
  return <MarkButton format="underline" Icon={<FormatUnderlinedIcon fontSize="small" />} />;
}

export default UnderlineButton;
